import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Collapse } from 'react-bootstrap';
import { i18n, getLocale } from 'core/i18n';
import Tools from 'core/tools';
import SideMenu from 'components/sideMenu';
import Dialog from 'components/dialog/index';
import InputField from 'components/inputField/index';
import Select from 'components/reactSelect/index';
import CheckBox from 'components/checkbox/index';
import Button from 'components/button/index';

import './register.css';

import {
  initRegister,
  clearRegister,
  postSubAgent,
  updateAgentInfo
} from './action';

import {
  postRole
} from '../mainModule/action';

class RegisterIndex extends Component {
  constructor(props) {
    super(props);
    this.handleSelectDefault = this.handleSelectDefault.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    
    this.state = {
      addressSameAsOrg: false
    };
  }

  async componentDidMount() {
    const self = this,
      { props } = self,
      {
        mainState,
        dispatch = () => { }
      } = props,
      {
        roleOptions
      } = mainState;
    
    if (!roleOptions) {
      await dispatch(postRole());
    }
    await dispatch(initRegister());
  }

  componentWillUnmount() {
     const self = this,
      { props } = self,
      { dispatch = () => { } } = props;
    
    dispatch(clearRegister());
  }

  handleSelectDefault(options, value) {
		let defaultValue = null;

		if (options) {
			for (let i = 0; i < options.length; i++) {
				if (options[i].value === value) {
					defaultValue = options[i];
					break;
				}
			}
		}
		
		return defaultValue;
	}

  handleSelectChange(type, value) {
    const self = this,
			{
				props
			} = self,
			{
				state,
				dispatch = () => { }
			} = props,
			{
				agentInfo
			} = state;
    let newAgentInfo = JSON.parse(JSON.stringify(agentInfo));
    
    switch (type) {
      case 'mobilePhone_dialCode':
        newAgentInfo.mobilePhone.dialCode = value;
        break;
      case 'workPhone_dialCode':
        newAgentInfo.workPhone.dialCode = value;
        break;
      default:
        newAgentInfo[type] = value;
        break;
    }

    dispatch(updateAgentInfo(newAgentInfo));
  }

  handleInputChange(type, value) {
    const self = this,
			{
				props
			} = self,
			{
				state,
				dispatch = () => { }
			} = props,
			{
				agentInfo
			} = state;
    let newAgentInfo = JSON.parse(JSON.stringify(agentInfo));
    
    switch (type) {
      case 'mobilePhone_number':
        newAgentInfo.mobilePhone.number = value;
        break;
      case 'workPhone_number':
        newAgentInfo.workPhone.number = value;
        break;
      default:
        newAgentInfo[type] = value;
        break;
    }

    dispatch(updateAgentInfo(newAgentInfo));
  }

  render() {
    const self = this,
      {
        props,
        state: _state,
        handleSelectDefault = () => { },
        handleSelectChange = () => { },
        handleInputChange = () => { }
      } = self,
      {
        state,
        mainState,
        dispatch = () => { }
      } = props,
      {
        agentInfo,
        addressInfo,
        errors,
        showSuccessDialog
      } = state,
      {
        balanceInfo,
        langOptions,
        currencyOptions,
        titleOptions,
        dialCodeOptions,
        countryCodeOptions,
        roleOptions,
        statusOptions
      } = mainState,
      {
        addressSameAsOrg
      } = _state;
    
    return (
      <div className='register-container'>
        {/* success dialog */}
        <Dialog
          dialogId='register-success-dialog'
          maxWidth='xs'
          zIndex={2000}
          open={!!showSuccessDialog}
          onClose={() => {
            // 初始化捲軸位置
            if (typeof window !== 'undefined') {
              window.scrollTo({ top: 0, left: 0 });
            }
            let url = Tools.generateLocaleUrl(getLocale(), '/Home')
            props.history.push(url);
          }}
          title={i18n('success_heading')}
          actionsClassName='register-success-dialog-action'
          actions={[
            <Button
              size='large'
              className={'close-button'}
              onClick={() => {
                // 初始化捲軸位置
                if (typeof window !== 'undefined') {
                  window.scrollTo({ top: 0, left: 0 });
                }
                let url = Tools.generateLocaleUrl(getLocale(), '/Home')
                props.history.push(url);
              }}
            >
              {i18n('close')}
            </Button>
          ]}
        >
          <div className='register-success-dialog-body'>{i18n('success_message_subagent_register')}</div>
        </Dialog>
        <div className='area-left'>
          <div className='register-header'>{i18n('register_sub_agent')}</div>
          {
            agentInfo ? (
              <div className='register-body'>                
                {/* 登入資訊 */}
                <div className='register-panel login'>
                  <div className='register-panel-title'>
                    <img alt='' src={require('assets/images/passenger.svg')} />
                    <span>{i18n('login_info')}</span>
                  </div>
                  <div className='register-panel-content'>
                    <div className='register-panel-row'>
                      {/* 旅行社組織 */}
                      <div className='register-panel-item'>
                        <div className='register-panel-label'>{i18n('login_info_org_code')}</div>
                        <InputField
                          disabled={true}
                          onBlurActEvent={(data) => {
                            handleInputChange('organizationCode', data);
                          }}
                          defaultValue={agentInfo.organizationCode || ''}
                          validateMessage={errors && errors.organizationCode ? i18n('error_organization_name') : null}
                        />
                      </div>
                      {/* 旅行社登入帳號 */}
                      <div className='register-panel-item'>
                        <div className='register-panel-label'>{i18n('login_info_org_status')}</div>
                        <Select
                          id={'register-status'}
                          isSearchable={false}
                          placeholder={agentInfo.agentStatus}
                          defaultValue={handleSelectDefault(statusOptions, agentInfo.agentStatus)}
                          options={statusOptions}
                          onChangeEvent={(data) => {
                            handleSelectChange('agentStatus', data.value);
                          }}
                          errorText={errors && errors.agentStatus ? i18n('error_agent_status') : null}
                        />
                      </div>
                    </div>
                    <div className='register-panel-row'>
                      {/* Skyagent 登入帳號 */}
                      <div className='register-panel-item'>
                        <div className='register-panel-label'>{i18n('login_info_agent_id')}</div>
                        <InputField
                          disabled={true}
                          onBlurActEvent={(data) => {
                            handleInputChange('mainAgentName', data);
                          }}
                          defaultValue={agentInfo.mainAgentName || ''}
                          // validateMessage={errors && errors.mainAgentName ? i18n('error_main_agent_name') : null}
                        />
                      </div>
                      {/* 子帳號 */}
                      <div className='register-panel-item'>
                        <div className='register-panel-label'>{i18n('login_info_sub_agent_id')}</div>
                        <InputField
                          inputType={'agentName'}
                          maxLength={'6'}
                          onBlurActEvent={(data) => {
                            handleInputChange('agentName', data);
                          }}
                          defaultValue={agentInfo.agentName || ''}
                          validateMessage={errors && errors.agentName ? i18n('error_agent_name') : null}
                        />
                      </div>
                    </div>
                    <div className='register-panel-row'>
                      {/* Skyagent 登入帳號 */}
                      <div className='register-panel-item'>
                        <div className='register-panel-label'>{i18n('login_info_agent_type')}</div>
                        <Select
                          id={'register-currency'}
                          isSearchable={false}
                          placeholder={agentInfo.agentType}
                          defaultValue={handleSelectDefault(roleOptions, agentInfo.agentType)}
                          options={roleOptions}
                          onChangeEvent={(data) => {
                            handleSelectChange('agentType', data.value);
                          }}
                          errorText={errors && errors.agentType ? i18n('error_agent_type') : null}
                        />
                      </div>
                      <div className='register-panel-item'></div>
                    </div>
                  </div>
                </div>
                {/* 設定 */}
                <div className='register-panel setting'>
                  <div className='register-panel-title'>
                    <img alt='' src={require('assets/images/setting.svg')} />
                    <span>{i18n('settings')}</span>
                  </div>
                  <div className='register-panel-content'>
                    <div className='register-panel-row'>
                      {/* 幣值 */}
                      <div className='register-panel-item'>
                        <div className='register-panel-label'>{i18n('settings_currency')}</div>
                        <Select
                          id={'register-currency'}
                          isSearchable={false}
                          isDisabled={true}
                          placeholder={agentInfo.preferredCurrency}
                          defaultValue={handleSelectDefault(currencyOptions, agentInfo.preferredCurrency)}
                          options={currencyOptions}
                          onChangeEvent={(data) => {
                            handleSelectChange('preferredCurrency', data.value);
                          }}
                          errorText={errors && errors.preferredCurrency ? i18n('error_preferred_currency') : null}
                        />
                      </div>
                      {/* 語言 */}
                      <div className='register-panel-item'>
                        <div className='register-panel-label'>{i18n('settings_language')}</div>
                        <Select
                          id={'register-language'}
                          isSearchable={false}
                          placeholder={i18n('placeholder')}
                          defaultValue={handleSelectDefault(langOptions, agentInfo.preferredLanguage)}
                          options={langOptions}
                          onChangeEvent={(data) => {
                            handleSelectChange('preferredLanguage', data.value);
                          }}
                          errorText={errors && errors.preferredLanguage ? i18n('error_preferred_language') : null}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* 聯絡人詳細資訊 */}
                <div className='register-panel contact'>
                  <div className='register-panel-title'>
                    <img alt='' src={require('assets/images/passenger.svg')} />
                    <span>{i18n('contact')}</span>
                  </div>
                  <div className='register-panel-content'>
                    <div className='register-panel-row'>
                      <div className='register-panel-item width-fifty'>
                        {/* 稱謂 */}
                        <div>
                          <div className='register-panel-label'>{i18n('contact_title')}</div>
                          <Select
                            id={'register-title'}
                            isSearchable={false}
                            placeholder={i18n('placeholder')}
                            defaultValue={handleSelectDefault(titleOptions, agentInfo.title)}
                            options={titleOptions}
                            onChangeEvent={(data) => {
                              handleSelectChange('title', data.value);
                            }}
                            errorText={errors && errors.title ? i18n('error_title') : null}
                          />
                        </div>
                        {/* 名字 */}
                        <div>
                          <div className='register-panel-label'>{i18n('first_name')}</div>
                          <InputField
                            inputType={'name'}
                            onBlurActEvent={(data) => {
                              handleInputChange('firstName', data);
                            }}
                            defaultValue={agentInfo.firstName || ''}
                            validateMessage={errors && errors.firstName ? i18n('error_first_name') : null}
                          />
                        </div>
                      </div>
                      {/* 姓氏 */}
                      <div className='register-panel-item'>
                        <div className='register-panel-label'>{i18n('last_name')}</div>
                        <InputField
                          inputType={'name'}
                          onBlurActEvent={(data) => {
                            handleInputChange('lastName', data);
                          }}
                          defaultValue={agentInfo.lastName || ''}
                          validateMessage={errors && errors.lastName ? i18n('error_last_name') : null}
                        />
                      </div>
                    </div>
                    <div className='register-panel-row'>
                      {/* 手機號碼 */}
                      <div className='register-panel-item width-fifty'>
                        <div>
                          <div className='register-panel-label'>{i18n('contact_mobile_number')}</div>
                          <Select
                            id={'register-mobile-dial-code'}
                            placeholder={i18n('placeholder')}
                            defaultValue={handleSelectDefault(dialCodeOptions[getLocale()], agentInfo.mobilePhone.dialCode)}
                            options={dialCodeOptions[getLocale()]}
                            onChangeEvent={(data) => {
                              handleSelectChange('mobilePhone_dialCode', data.value);
                            }}
                            errorText={errors && errors.mobilePhone && errors.mobilePhone.dialCode ? i18n('error_mobile_code') : null}
                          />
                        </div>
                        <div>
                          <div className='register-panel-label'></div>
                          <InputField
                            inputType={'tel'}
                            onBlurActEvent={(data) => {
                              handleInputChange('mobilePhone_number', data);
                            }}
                            defaultValue={agentInfo.mobilePhone.number || ''}
                            validateMessage={errors && errors.mobilePhone && errors.mobilePhone.number ? i18n('error_mobile_number') : null}
                          />
                        </div>
                      </div>
                      {/* 公司電話 */}
                      <div className='register-panel-item width-fifty'>
                        <div>
                          <div className='register-panel-label'>{i18n('contact_office_number')}</div>
                          <Select
                            id={'register-office-dial-code'}
                            placeholder={i18n('placeholder')}
                            defaultValue={handleSelectDefault(dialCodeOptions[getLocale()], agentInfo.workPhone.dialCode)}
                            options={dialCodeOptions[getLocale()]}
                            onChangeEvent={(data) => {
                              handleSelectChange('workPhone_dialCode', data.value);
                            }}
                            errorText={errors && errors.workPhone && errors.workPhone.dialCode ? i18n('error_office_code') : null}
                          />
                        </div>
                        <div>
                          <div className='register-panel-label'></div>
                          <InputField
                            inputType={'tel'}
                            onBlurActEvent={(data) => {
                              handleInputChange('workPhone_number', data);
                            }}
                            defaultValue={agentInfo.workPhone.number || ''}
                            validateMessage={errors && errors.workPhone && errors.workPhone.number ? i18n('error_office_number') : null}
                          />
                        </div>
                      </div>
                    </div>
                    <div className='register-panel-row'>
                      {/* 電子郵件 */}
                      <div className='register-panel-item'>
                        <div className='register-panel-label'>{i18n('contact_email')}</div>
                        <InputField
                          inputType={'email'}
                          maxLength={'50'}
                          onBlurActEvent={(data) => {
                            handleInputChange('email', data);
                          }}
                          defaultValue={agentInfo.email || ''}
                          validateMessage={errors && errors.email ? i18n('error_email') : null}
                        />
                      </div>
                      {/* 確認電子郵件 */}
                      <div className='register-panel-item'>
                        <div className='register-panel-label'>{i18n('contact_confirm_email')}</div>
                        <InputField
                          inputType={'email'}
                          maxLength={'50'}
                          onBlurActEvent={(data) => {
                            handleInputChange('confirmEmail', data);
                          }}
                          defaultValue={agentInfo.confirmEmail || ''}
                          validateMessage={errors && errors.confirmEmail ? i18n('error_confirm_email') : null}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* 地址 */}
                <div className='register-panel address'>
                  <div className='register-panel-title address'>
                    <div>
                      <img alt='' src={require('assets/images/address.svg')} />
                      <span>{i18n('address')}</span>
                    </div>
                    <CheckBox
                      id={'same-as-org'}
                      className={'same-as-org'}
                      value={addressSameAsOrg}
                      checked={addressSameAsOrg}
                      text={i18n('same_as_org')}
                      onClick={() => {
                        // 取消勾選 "地址同註冊地址"，則清空地址資訊
                        if (addressSameAsOrg) {
                          let newAgentInfo = JSON.parse(JSON.stringify(agentInfo));
                      
                          if (newAgentInfo.address1) newAgentInfo.address1 = null;
                          if (newAgentInfo.address2) newAgentInfo.address2 = null;
                          if (newAgentInfo.city) newAgentInfo.city = null;
                          if (newAgentInfo.addressState) newAgentInfo.addressState = 'OTH';
                          if (newAgentInfo.country) newAgentInfo.country = null;
                          if (newAgentInfo.postalCode) newAgentInfo.postalCode = null;

                          dispatch(updateAgentInfo(newAgentInfo));
                        }

                        self.setState({
                          addressSameAsOrg: !addressSameAsOrg
                        });
                      }}
                    />
                  </div>
                  <Collapse in={!addressSameAsOrg || !addressInfo}>
                    <div className='register-panel-content'>
                      <div className='register-panel-row'>
                        {/* 地址 1 */}
                        <div className='register-panel-item'>
                          <div className='register-panel-label'>{i18n('address_line_1')}</div>
                          <InputField
                            maxLength={'52'}
                            onBlurActEvent={(data) => {
                              handleInputChange('address1', data);
                            }}
                            defaultValue={agentInfo.address1 || ''}
                            validateMessage={errors && errors.address1 ? i18n('error_address_1') : null}
                          />
                        </div>
                        {/* 地址 2 */}
                        <div className='register-panel-item'>
                          <div className='register-panel-label'>{i18n('address_line_2')}</div>
                          <InputField
                            maxLength={'52'}
                            onBlurActEvent={(data) => {
                              handleInputChange('address2', data);
                            }}
                            defaultValue={agentInfo.address2 || ''}
                            // validateMessage={errors && errors.address2 ? i18n('error_address_2') : null}
                          />
                        </div>
                      </div>
                      <div className='register-panel-row'>
                        {/* 城鎮 */}
                        <div className='register-panel-item'>
                          <div className='register-panel-label'>{i18n('address_city')}</div>
                          <InputField
                            onBlurActEvent={(data) => {
                              handleInputChange('city', data);
                            }}
                            defaultValue={agentInfo.city || ''}
                            validateMessage={errors && errors.city ? i18n('error_city') : null}
                          />
                        </div>
                        {/* 國家 */}
                        <div className='register-panel-item'>
                          <div className='register-panel-label'>{i18n('address_country')}</div>
                          {
                            !addressSameAsOrg ? (
                              <Select
                                id={'register-country'}
                                placeholder={i18n('placeholder')}
                                defaultValue={handleSelectDefault(countryCodeOptions[getLocale()], agentInfo.country)}
                                options={countryCodeOptions[getLocale()]}
                                onChangeEvent={(data) => {
                                  handleSelectChange('country', data.value);
                                }}
                                errorText={errors && errors.country ? i18n('error_country') : null}
                              />
                            ) : null
                          }
                        </div>
                      </div>
                      <div className='register-panel-row'>
                        {/* 郵遞區號 */}
                        <div className='register-panel-item'>
                          <div className='register-panel-label'>{i18n('address_postal_code')}</div>
                          <InputField
                            onBlurActEvent={(data) => {
                              handleInputChange('postalCode', data);
                            }}
                            defaultValue={agentInfo.postalCode || ''}
                            // validateMessage={errors && errors.postalCode ? i18n('error_postal_code') : null}
                          />
                        </div>
                        <div className='register-panel-item'></div>
                      </div>
                    </div>
                  </Collapse>
                </div>
                {/* 設定密碼 */}
                <div className='register-panel'>
                  <div className='register-panel-title'>
                    <img alt='' src={require('assets/images/password.svg')} />
                    <span>{i18n('password_set_pw')}</span>
                  </div>
                  <div className='register-panel-content'>
                    <div className='register-panel-row'>
                      {/* 密碼 */}
                      <div className='register-panel-item'>
                        <div className='register-panel-label'>{i18n('password')}</div>
                        <InputField
                          type={'password'}
                          inputType={'password'}
                          maxLength={'16'}
                          value={agentInfo.password || ''}
                          onBlurActEvent={(data) => {
                            handleInputChange('password', data);
                          }}
                          validateMessage={errors && errors.password ? i18n('error_password') : null}
                        />
                      </div>
                      {/* 確認密碼 */}
                      <div className='register-panel-item'>
                        <div className='register-panel-label'>{i18n('password_confirm_pw')}</div>
                        <InputField
                          type={'password'}
                          inputType={'password'}
                          maxLength={'16'}
                          value={agentInfo.confirmPassword || ''}
                          onBlurActEvent={(data) => {
                            handleInputChange('confirmPassword', data);
                          }}
                          validateMessage={errors && errors.confirmPassword ? i18n('error_confirm_password') : null}
                        />
                      </div>
                    </div>
                    <div className='register-panel-instruction'>{`* ${i18n('password_instruction')}`}</div>
                  </div>
                </div>
                {/* 儲存 */}
                <div className='register-panel-button'>
                  <Button
                    className={'primary-button'}
                    onClick={() => {
                      let newAgentInfo = JSON.parse(JSON.stringify(agentInfo));
                      
                      // 如果有勾選 "地址同註冊地址"，則帶入addressInfo
                      if (addressSameAsOrg && addressInfo) {
                        newAgentInfo.address1 = addressInfo.address1;
                        newAgentInfo.address2 = addressInfo.address2;
                        newAgentInfo.city = addressInfo.city;
                        newAgentInfo.addressState = addressInfo.addressState;
                        newAgentInfo.country = addressInfo.country;
                        newAgentInfo.postalCode = addressInfo.postalCode;
                      }

                      dispatch(updateAgentInfo(newAgentInfo));
                      dispatch(postSubAgent(newAgentInfo));
                    }}
                  >
                    {i18n('save')}
                  </Button>
                </div>
              </div>
            ) : null
          }
        </div>
        <SideMenu
          balanceInfo={balanceInfo}
        />
      </div>
    );
  }
}

let mapStateToProps = (state) => {
  return {
    state: state.registerReducer,
    mainState: state.mainReducer
  };
};

export default connect(mapStateToProps)(withRouter(RegisterIndex));